import React, { useState } from 'react';
import styles from './InputPage.module.css';
import RenderComponente from './RenderComponente';
import logo from '../assets/logo.png';

export default function InputPage({ onAnalisar, onDemo, loading, erro, resultado, parametro, tipo, user, onLogout }) {
  const [input, setInput] = useState('');
  const [parseErro, setParseErro] = useState(null);

  function handleSubmit() {
    setParseErro(null);

    if (!input.trim()) {
      setParseErro('Informe um dado para análise.');
      return;
    }

    onAnalisar(input.trim());
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !loading) {
      handleSubmit();
    }
  }

  function fillExample(text) {
    const clean = text.split(': ')[1] || text;
    setInput(clean);
    setParseErro(null);
  }

  return (
    <div  className="history-root">
      {/* Header */}
      {/* <header className={styles.header}>
        <div className={styles.logo}>
          <img
            src={logo}
            alt="Analise Central"
            className={styles.logoImage}
          />
        </div>
        <div className={styles.accountBox}>
          <div className={styles.accountMeta}>
            <strong>{user?.empresa || 'Conta autenticada'}</strong>

            <span
              className={`${styles.creditInfo} ${
                user?.creditsExpired ? styles.creditExpired : ''
              }`}
            >
              {user?.credits ?? 0} {
                user?.creditsExpired ? 'expirados' : ' créditos'
              }
            </span>
          </div>
          <a href="/recargas" className={styles.btnRecargas}>
            Recargas
          </a>
          <a href="/historico" className={styles.btnRecargas}>
            Historico
          </a>
          <button className={styles.btnLogout} onClick={onLogout} type="button">
            Sair
          </button>
        </div>
      </header> */}

      <header className="history-header">
        <div className="container">
          <div className="history-header-inner">
            <a href="/" className="history-logo">Análise Central</a>
            <nav className="history-header-nav">
              <a href="#" className="active">Inicio</a>
              <a href="/historico" >Histórico</a>
              <a href="/recargas" >Recargas</a>
            </nav>
            <div className="history-user">
              <div style={{display: 'flex', flexDirection: 'column'}}>
              <span className="user-name">{user?.empresa || 'Conta autenticada'}</span>
              <span
              className={`${styles.creditInfo} ${
                user?.creditsExpired ? styles.creditExpired : ''
              }`}
            >
              {user?.credits ?? 0} {
                user?.creditsExpired ? 'expirados' : ' créditos'
              }
            </span>
            </div>
              <button className="btn-sair" onClick={onLogout}>Sair</button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="history-hero">
        <div className="container">
          <h1>Antifraude para <span className={styles.heroAccent}>revendas</span></h1>
          <p className="history-hero-desc">
            Consulte e valide dados em segundos.
          </p>
        </div>
      </div>
      

      <main className={styles.main}>
        {/* Hero */}
        {/* <div className={styles.hero}>
          <h1 className={styles.heroTitle}>
            Valide seu <span className={styles.heroAccent}>cliente</span>
          </h1> 
          <p className={styles.heroSub}>
            Consulte e valide dados em segundos.
          </p>
        </div>*/}

        {/* Card */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <span className={styles.cardLabel}>Dados do cliente</span>
            <span className={styles.cardHint}>
              CPF, CNPJ, telefone, nome, e-mail ou pelo comprovante pix
            </span>
          </div>

          <div className={styles.inputWrapper}>
            <input
              className={styles.input}
              type="text"
              value={input}
              onChange={e => {
                setInput(e.target.value);
                setParseErro(null);
              }}
              onKeyDown={handleKeyDown}
              placeholder="Ex: 062.XXX.XXX-XX ou João da Silva"
              autoComplete="off"
              spellCheck="false"
            />
          </div>

          {(parseErro || erro) && (
            <div className={styles.erroBox}>
              <span>⚠️</span>
              {parseErro || erro}
            </div>
          )}

          <div className={styles.actions}>
            <button
              className={styles.btnAnalisar}
              onClick={handleSubmit}
              disabled={loading}
              type="button"
            >
              {loading ? (
                <span className={styles.spinner}>Analisando</span>
              ) : (
                <>
                  Analisar cliente
                  <span>→</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Result */}
        {resultado && (
          <div className={styles.resultSection}>
            <RenderComponente
              resultado={resultado}
              parametro={parametro}
              tipo={tipo}
              setInput={setInput}
              onConsultar={onAnalisar}
            />
          </div>
        )}
      </main>
    </div>
  );
}